import dayjs, { Dayjs } from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(relativeTime)
dayjs.extend(isSameOrAfter)
dayjs.extend(advancedFormat)

declare module 'dayjs' {
  interface Dayjs {
    fromNow(input: any): string
    isSameOrAfter(input: any): boolean
  }
}

export default dayjs
export { Dayjs }
